import { render, staticRenderFns } from "./FluxoTemplatePreview.vue?vue&type=template&id=b6cbefbc&scoped=true&"
import script from "./FluxoTemplatePreview.vue?vue&type=script&lang=js&"
export * from "./FluxoTemplatePreview.vue?vue&type=script&lang=js&"
import style0 from "./FluxoTemplatePreview.vue?vue&type=style&index=0&id=b6cbefbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cbefbc",
  null
  
)

export default component.exports